import loginPage from "@image/memberFunction/07/login_success.png";
import info_bar_s from "@image/memberFunction/07/info_bar_s.png";
import info_bar from "@image/memberFunction/07/info_bar.png";
import login_big_btn from "@image/memberFunction/07/login_big_btn.png";
import news_line from "@image/memberFunction/08/news_line.png";
import detail_board from "@image/memberFunction/08/detail_board.png";
export default [
  loginPage,
  info_bar_s,
  info_bar,
  login_big_btn,
  news_line,
  detail_board,
];
